/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_StaleInputs */

const en_issue_stale = /** @type {(inputs: Issue_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`calculated before the Price Setup changed: recalculate`)
};

/**
* | output |
* | --- |
* | "calculated before the Price Setup changed: recalculate" |
*
* @param {Issue_StaleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_stale = /** @type {((inputs?: Issue_StaleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_StaleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_stale(inputs)
});